import { createContext, useState, useEffect } from "react";
import useExtraFunctions from "../hooks/useExtraFunctions";
const CalenderContext = createContext<{
    startDate: Date | null;
    endDate: Date | null;
    isDateValid: boolean;
    setIsDateValid: (isDateValid: boolean) => void;
    setStartDate: (date: Date | null) => void;
    setEndDate: (date: Date | null) => void;
    isCalenderOpen: boolean;
    setIsCalenderOpen: (isCalenderOpen: boolean) => void;
}>({ startDate: null, endDate: null, isDateValid: false, setStartDate: () => {}, setEndDate: () => {}, setIsDateValid: () => {}, isCalenderOpen: false, setIsCalenderOpen: () => {} });

export default CalenderContext;

const CalenderProvider = ({ children }: { children: React.ReactNode }) => {
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [isDateValid, setIsDateValid] = useState<boolean>(false);

    const [isCalenderOpen, setIsCalenderOpen] = useState<boolean>(false);

    const { DateCompare } = useExtraFunctions();

    useEffect(() => {
        
        if (DateCompare(startDate, endDate)) {
            setIsDateValid(true);
        } else {
            setIsDateValid(false);
        }
    }, [startDate, endDate]);

    return <CalenderContext.Provider value={{ startDate, endDate, isDateValid, setStartDate, setEndDate, setIsDateValid, isCalenderOpen, setIsCalenderOpen }}>{children}</CalenderContext.Provider>
}

export { CalenderProvider };